import React from 'react';
import { Events } from 'components/events/Events';

export const EventsSlice = ({ items }) => {
  return <Events items={items} />;
};

export default EventsSlice;
